import Vue from 'vue';
const vue = new Vue();

class NotificationService {

    type(type) {
        this.type = type;
        return this; 
    }

    message(msg) {
        this.message = msg;
        return this; 
    }

    title(title) {
        this.title = title;
        return this; 
    }

    duration(duration) {
        this.duration = duration;
        return this; 
    }
    notify() {
        vue.$notify({
            position: 'top right',
            group: 'base',
            type: this.type,
            title: this.title,
            text: this.message,
            duration: this.duration,
            speed: 1000,
        });
    }
}

export default NotificationService;


// WEBPACK FOOTER //
// ./src/js/plugins/notify.js